import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ApiModulesService} from 'src/app/api-modules.service';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
    username = [];
    mobilenumber = [];
    status = [];
    blocked_message = [];
    blocked_add_channel = [];


    EditUser: FormGroup;
    @Input() id = [];
    @Output() visibleParentPage: EventEmitter<any> = new EventEmitter<any>();

    constructor(private apiModulesService: ApiModulesService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
    }
    ngOnInit() {

        this.EditUser = this.formBuilder.group({
            id: [''],
            status: ['', []],
            api_id: [''],
            api_hash: [''],
            username: [''],
            mobilenumber: [''],
            blocked_message: ['', []],
            blocked_add_channel: ['', []]


    });


        this.editTelegramUser();

    }




    public updateEditUser() {
        const params: any = {};
        console.log('befire');
        params.id = this.EditUser.value.id;
        params.username = this.EditUser.value.username;
        params.mobilenumber = this.EditUser.value.mobilenumber;
        params.status = this.EditUser.value.status;
        params.blocked_message = this.EditUser.value.blocked_message;
        params.blocked_add_channel = this.EditUser.value.blocked_add_channel;
        params.api_id = this.EditUser.value.api_id;
        params.api_hash = this.EditUser.value.api_hash;

        params.id = this.id;
        console.log('after');
        console.log(this.EditUser);
        this.apiModulesService.add(params, 'telegram/user/update').subscribe((data) => {
            this.EditUser = data;
            console.log(this.EditUser);
            this.moveToMainPage();
        });
    }

    public editTelegramUser() {
        const params: any = {};
        params.id = this.id;
        this.apiModulesService.add(params, 'telegram/user/view').subscribe((data) => {
            const user = data;
            console.log(user);
            this.EditUser.setValue({
                id:  (Number) (user.id),
                username: (String) (user.username),
                mobilenumber: (String) (user.mobilenumber),
                status: (Number) (user.status),
                blocked_message: (Number) (user.blocked_message),
                blocked_add_channel: (Number) (user.blocked_add_channel),
                api_id: (String)(user.api_id),
                api_hash: (String)(user.api_hash)
            });
            console.log(this.EditUser);


        });
    }

    public moveToMainPage() {
        this.visibleParentPage.emit(true);

    }
}


